import 'firebase/firestore';

import { db, dueCardNotifications } from '@/db/firestore';
import { DueCardNotificationModel } from '@/models/DueCardNotification';
import { Mapper } from '@/db/Mapper';


export class Learning {
    public async dueCardsByUser(userId: string): Promise<DueCardNotificationModel[]> {
    const mapper = new Mapper(DueCardNotificationModel);
    
    const snapshot = await dueCardNotifications
                    .where('userId', '==', userId)
                    .where('due', '<', new Date())
                    .get();
                    
    const data = mapper.AutoMapList(snapshot);

    return data;

    }
}